/**
 * ModulePreview Component Package
 *
 * Provides components for previewing modules and tasks as they would appear
 * to students in the learning interface.
 */

import ModulePreviewContainer from './ModulePreviewContainer';

// Export the main container component
export { ModulePreviewContainer };

// Export sub-components
export { default as ModulePreviewHeader } from './components/ModulePreviewHeader';
export { default as ModulePreviewNavigation } from './components/ModulePreviewNavigation';
export { default as CoursePreview } from './components/CoursePreview';
export { default as ModulePreview } from './components/ModulePreview';

// Export hooks for access to preview state
export {
  usePreviewModal,
  usePreviewNavigation,
  usePreviewContent,
} from './hooks/useModulePreviewStore';

export { default as useModulePreviewData } from './hooks/useModulePreviewData';

// Default export for convenience
export default ModulePreviewContainer;
